export default __webpack_public_path__ + "static/media/EmbeddedDev_Security.16863063.png";